module.exports = __webpack_public_path__ + "assets/img/cbaf17a969314d5d508b99a6d6e8348a.svg";